import { EmphasisLevel } from './EmphasisLevel';

export const getEmphasisLevel = <T extends unknown>(activeSeriesDataKey: T, currentSeriesDataKey: T): EmphasisLevel => {
  switch (activeSeriesDataKey) {
    case undefined:
      return 'none';
    case currentSeriesDataKey:
      return 'emphasized';
    default:
      return 'deemphasized';
  }
};
